import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Feed",
    component: Home,
  },
  {
    path: "/creators",
    name: "Creators",
    component: () =>
      import(/* webpackChunkName: "creators" */ "../views/Creators.vue"),
  },
  {
    path: "/about",
    name: "About",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/merch",
    name: "Merch",
    component: () =>
      import(/* webpackChunkName: "merch" */ "../views/Merch.vue"),
  },
  {
    path: "/sponsors",
    name: "Sponsors",
    component: () =>
      import(/* webpackChunkName: "sponsors" */ "../views/Sponsors.vue"),
  },
  {
    path: "/contact",
    name: "Contact",
    component: () =>
      import(/* webpackChunkName: "contact" */ "../views/Contact.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
